module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-5-selected.d863d129.png";